const breakpoints = {
  values: {
    xxxs: 0,
    xxs: 400,
    xs: 600,
    sm: 840,
    md: 960,
    lg: 1280,
    xl: 1440,
    xxl: 1600,
    xxxl: 1920,
  },
};

export default breakpoints;
